import { saveAs as importedSaveAs } from "file-saver";

import {
  created_by,
  otherAPIHeaders,
  uploadAPIHeaders,
} from "../shared-resources/dumpData";

export function createResourceAPI(body) {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/resource/createResource`, {
    method: "POST",
    headers: otherAPIHeaders,
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceAnalyticsAPI(body, id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAnalyticsData?departmentId=${id}&isShowInactive=${isShowInactive}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourcesByRolesAPI(body, id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourcesByRoles?departmentId=${id}&isShowInactive=${isShowInactive}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getTotalResourcesAPI(body, id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getTotalResource?departmentId=${id}&isShowInactive=${isShowInactive}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceDetailsByIdAPI(id, financialYear) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceDetailsById?resourceId=${id}&financialYear=${financialYear}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateResourceDetailsByIdAPI(id, body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/updateResourceDetailsById?resourceId=${id}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceAllocationMatrixAPI(id, body) {
  return fetch(
    // `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationMatrix`,
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationMatrixNew?departmentId=${id}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getResourceAllocationDataLimitsByMapIdAPI(id, mapId, body) {
  return fetch(
    // `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationMatrix`,
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationDataLimitsByMapId?resourceId=${id}&mapId=${mapId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateProjectResourceAllocationAPI(
  body,
  mapId,
  allocationFrequency,
  modifiedBy
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/createUpdateProjectResourceAllocation?mapId=${mapId}&allocationFrequency=${allocationFrequency}&modifiedBy=${modifiedBy}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify({
        ...body,
        modifiedBy: created_by,
        modifiedDate: new Date(),
      }),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getUtilizationLevelAPI(body, id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getUtilizationLevel?departmentId=${id}&isShowInactive=${isShowInactive}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getUtilizationPercentAPI(body, id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getUtilizationPercent?departmentId=${id}&isShowInactive=${isShowInactive}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getProjectNotificationAPI(notificationType, showFulfilled) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceRequestPM?notificationType=${notificationType}&showFulfilled=${showFulfilled}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getResourceNotificationAPI(notificationType, showFulfilled) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceRequest?notificationType=${notificationType}&showFulfilled=${showFulfilled}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getDepartmentsAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/departmentDropdownOptions`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectListAPI() {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/project/getProjectList`)
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourcesByLocationAPI(body, id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourcesByLocation?departmentId=${id}&isShowInactive=${isShowInactive}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getUtilizationGraphAPI(id, isShowInactive) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getUtilizationGraph?resourceId=${id}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getInHouseResourceDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getInHouseResourceDetails?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getVendorResourceDetailsAPI(year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getVendorResourceDetails?financialYear=${year}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourcesByDepartmentAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourcesByDepartment`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourcesByProjectAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourcesByProject`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourcesByUtilizationAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourcesByUtilization`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceAllocationMatrixNewAPI(body, dropdown, id) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationMatrix?dropdown=${dropdown}&id=${id}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAllocationDataByMapIdAPI(mapId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getAllocationDataByMapId?mapId=${mapId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getResourcesByProjectOwnerAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourcesByProjectOwner`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceAllAllocationsChartAPI(
  resourceId,
  year,
  type,
  id,
  frequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllAllocationsChart?resourceId=${resourceId}&financialYear=${year}&dropdown=${type}&id=${id}&allocationFrequency=${frequency}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateResourceAllAllocationsChartAPI(
  frequency,
  body,
  goBeyondAvailableFteLimit
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/updateResourceAllAllocationsChart?allocationFrequency=${frequency}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadCreateResourceExcelFileAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/downloadCreateResourceExcelFile`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function createResourceFromExcelAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/createResourceFromExcel`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getResourceAllocationChartForAllResourcesAPI(body, year) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationChartForAllResources?financialYear=${year}`,
    { method: "POST", headers: otherAPIHeaders, body: JSON.stringify(body) }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getDepartmentResourcesAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceListForDepartmentHead`,
    {
      method: "GET",
      headers: uploadAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getResourceHierarchysAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceHierarchy`,
    {
      method: "GET",
      headers: uploadAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getSpecificResourceHierarchysAPI() {
  return fetch(
    `${
      process.env.KIRKLAND_APP_API_URL
    }/resource/getSpecificResourceHierarchy?userEmail=${localStorage.getItem(
      "email"
    )}`,
    {
      method: "GET",
      headers: uploadAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadResourceAnalyticsAPI(body, departmentId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/downloadResourceAnalytics?departmentId=${departmentId}`,
    {
      method: "POST",
      headers: { ...uploadAPIHeaders, ["Content-Type"]: "application/json" },
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function downloadFilteredResourceAnalyticsAPI(body, departmentId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/downloadFilteredResourceAnalytics?departmentId=${departmentId}`,
    {
      method: "POST",
      headers: { ...uploadAPIHeaders, ["Content-Type"]: "application/json" },
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getDepartmentAllResourceAllocationsChartAPI(
  year,
  resourceId,
  frequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getDepartmentAllResourceAllocationsChart?resourceId=${resourceId}&financialYear=${year}&allocationFrequency=${frequency}
    `,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getSearchFiltersForUnnamedRequestAPI(requestId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getSearchFiltersForUnnamedRequest?requestId=${requestId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function assignResourceToUnnamedRequestAPI(requestId, resourceId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/assignUnnamedResourceToRequest?requestId=${requestId}&resourceId=${resourceId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function swapResourceforResourceRequestAPI(
  mapId,
  resourceId,
  roleId = "",
  body
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/swapResourceForResourceRequest?mapId=${mapId}&resourceId=${resourceId}&roleId=${roleId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function sendResourceListEligibleForSwappingAPI(projectId, resourceId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/sendResourceListEligibleForSwapping?projectId=${projectId}&resourceId=${resourceId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceAllocationMatrixForAllResourcesAPI(
  option,
  year,
  id,
  frequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceAllocationMatrixForAllResources?dropdown=${option}&financialYear=${year}&id=${id}&allocationFrequency=${frequency}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getUserProfileDetailsAPI(email) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getUserProfileDetails?email=${email}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getNotificationCountAPI(isRMNotification) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getNotificationCount?isRMNotification=${isRMNotification}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function notificationViewedByUserAPI(isRmTrue, requestId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/notificationViewedByUser?isRmTrue=${isRmTrue}&requestId=${requestId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadRequestResponseActionReportAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/downloadRequestResponseActionReport`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getRequestResponseActionReportAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getRequestResponseActionReport`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadResourceAllAllocationsChartAPI(
  resourceId,
  year,
  type,
  id,
  frequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/downloadResourceAllAllocationsChart?resourceId=${resourceId}&financialYear=${year}&dropdown=${type}&id=${id}&allocationFrequency=${frequency}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => {
      let fileName = "";
      res.headers.forEach(function (val, key) {
        if (key === "content-disposition")
          fileName = val.split(";")[2].split('="')[1].split('.xlsx"')[0];
      });
      localStorage.setItem("downloadFileName", fileName);
      return res.blob();
    })
    .catch((err) => err);
}

export function acceptCompleteResourceRequestAPI(
  mapId,
  goBeyondAvailableFteLimit,
  body
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/acceptCompleteResourceRequest?mapId=${mapId}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function rejectResourceRequestAPI(mapId, body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/rejectResourceRequest?mapId=${mapId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateAllResourceAllAllocationsChartByProjectAPI(
  allocationFrequency,
  goBeyondAvailableFteLimit,
  body
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/updateAllResourceAllAllocationsChartByProject?allocationFrequency=${allocationFrequency}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function acceptAllCompleteResourceRequestsAPI(
  allowPastDataUpdate,
  goBeyondAvailableFteLimit,
  body
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/acceptAllCompleteResourceRequests?allowPastDataUpdate=${allowPastDataUpdate}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function acceptAllCompleteResourceRequestsByProjectAPI(
  allowPastDataUpdate,
  goBeyondAvailableFteLimit,
  body
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/acceptAllCompleteResourceRequestsByProject?allowPastDataUpdate=${allowPastDataUpdate}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getResourceRequestDetailsByMapIdAPI(mapId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getResourceRequestDetailsByMapId?mapId=${mapId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
